<template>
  <div class="date-time-picker">

    <date-picker
      :value="internalDateObject"
      :popover="popover"
      :default-date="dateNow"
      @input="emitDateInput"
    >
      <div class="input-group time-input-group">
        <input
          :name="fieldName"
          :disabled="disable"
          type="text"
          :key="reRenderKey"
          :value="showingValue"
          class="form-control"
          @keyup="typing=true"
          @focusout="emitDateStringInput"
          @paste="emitDateStringInput"
        />
        <span class="input-group-addon">
          <span class="glyphicon glyphicon-calendar"></span>
        </span>
      </div>
    </date-picker>
  </div>
</template>

<script>
import DatePicker from "v-calendar/lib/components/date-picker.umd.js";
import { getEventValue, transformDate } from "src/lib/editor/utils.js";

export default {
  name: "DateTimeSelector",
  components: {
    "date-picker": DatePicker,
  },
  props: {
    // The selected visible date
    value: {
      type: String,
      default: () => transformDate(new Date()),
    },
    disable: {
        type: Boolean,
        default: false,
    },
    // The color of the selected values
    color: {
      type: String,
      default: null,
    },
    // Used to handle YYYY-MM-DDThh:mm[:ss[.uuuuuu]][+HH:MM|-HH:MM|Z] format
    isDateTimeField: {
      type: Boolean,
      default: false,
    },
    // Name of this field
    fieldName: {
        type: String,
        default: ''
    }
  },
  data: () => ({
    dateNow: new Date(),
    showingValue: "",
    reRenderKey: "1",
    typing: false,
  }),
  computed: {
    internalDateObject: function() {
      if (this.value) {
        return new Date(this.value);
      } else {
        return new Date();
      }
    },
    popover: function() {
        return {placement: 'bottom', visibility: this.disable ? 'hidden' : 'click'}
    }
  },
  created: function () {
    if (this.value) {
      this.showingValue = this.value.substring(0, 10);
    }
  },
  methods: {
    emitDateInput: function (event) {
      if (!event) {
        this.$emit("input", null);
        this.showingValue = null;
        return;
      }
      let transformedDate = transformDate(event, this.isDateTimeField);
      let date = transformedDate;
      this.showingValue = date.substring(0, 10)
      this.$emit("input", transformedDate);
    },
    emitDateStringInput: function (event) {
        if (this.typing || (!this.typing && event.clipboardData)) {
            let value = this.typing ? getEventValue(event) : event.clipboardData.getData('text')
            let date = new Date(value);
            if (value === "" || (date != "Invalid Date" && value.length === 10)) {
                this.showingValue = value
                if (value != "") {
                    this.$emit("input", transformDate(date, this.isDateTimeField));
                } else {
                    this.$emit("input", null);
                }
                this.reRenderKey = this.reRenderKey + "1"
            } else {
                if (this.value) {
                    this.showingValue = this.value.substring(0, 10)
                    this.reRenderKey = this.reRenderKey + "1"
                    this.$emit("input", this.showingValue)
                } else {
                    this.showingValue = null
                    this.reRenderKey = this.reRenderKey + "1"
                    this.$emit("input", null)
                }
            }
            this.typing = false
        }
    },
  },
};
</script>

<style>
.date-time-picker > span > div.vc-popover-content-wrapper {
  z-index: 1100;
}

.date-time-picker .vc-title {
  color: black;
  font-size: 100%;
}
.date-time-picker .vc-container {
  font-family: Helvetica, "Helvetica Neue", sans-serif;
}

.date-time-picker .vc-weekday {
  color: black;
}

.date-time-picker .vc-border {
  border-width: 1px;
  border-radius: 4px;
  border-color: darkgray;
}

.date-time-picker .vc-svg-icon {
  /*
  These need to be important because v-calendar puts a data attribute on the class selector
  which makes it more specific
   */
  stroke: black !important;
  stroke-width: 3 !important;
}

.date-time-picker .vc-rounded-full {
  border-radius: 1px;
}
</style>
